<template>
    <v-card flat tile color="primary" class="mb-3 px-6 pt-4 pb-5">
        <v-container color="primary" pa-0 ma-0>
            <v-row
                class="ma-0 pa-0 mb-0 pb-0 align-center wallet-summary-balance"
            >
                <v-col class="pa-0 subtitle-1">{{
                    $vuetify.lang.t('$vuetify.widgets.wallet.account_balance')
                }}</v-col>
                <v-col
                    class="pa-0"
                    cols="auto"
                    v-if="currentUser && currentUser.wallet"
                >
                    {{ currentUser.wallet.balance | number
                    }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row
                class="ma-0 pa-0 mb-0 pb-0 align-center wallet-summary-pending"
            >
                <v-col class="pa-0 body-1">{{
                    $vuetify.lang.t(
                        '$vuetify.widgets.wallet.contracts_in_review'
                    )
                }}</v-col>
                <v-col class="pa-0" cols="auto">
                    {{ total | number | balance
                    }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                </v-col>
            </v-row>
            <v-divider class="my-3"></v-divider>
            <v-row
                class="ma-0 pa-0 mb-0 pb-0 align-center wallet-summary-pending"
            >
                <v-col class="pa-0">
                    <div class="pa-0 mb-2 body-1">
                        {{
                            $vuetify.lang.t(
                                '$vuetify.widgets.performance.expiring_points'
                            )
                        }}:
                    </div>
                    <div class="v-sheet v-sheet--tile bg-darken pa-2 mb-3">
                        <v-row class="ma-0 pa-0">
                            <v-col class="pa-0 body-1 font-weight-regular">
                                <div>
                                    {{
                                        $vuetify.lang.t(
                                            '$vuetify.widgets.performance.deadline_at',
                                            currentUser.wallet.next_deadline
                                        )
                                    }}:
                                </div>
                                <div
                                    class="font-weight-regular text--secondary"
                                >
                                    <router-link
                                        :to="staticRankUrl"
                                        class="d-inline-flex text--secondary"
                                    >
                                        {{
                                            $vuetify.lang.t(
                                                '$vuetify.widgets.performance.regular_points_expiry'
                                            )
                                        }}
                                    </router-link>
                                </div>

                                <div
                                    class="mt-2 text-primary font-weight-regular"
                                >
                                    {{
                                        $vuetify.lang.t(
                                            '$vuetify.widgets.performance.info'
                                        )
                                    }}
                                </div>
                            </v-col>
                            <v-col class="col-auto pa-0 text-right body-1">
                                {{ currentUser.wallet.points_to_expire | number
                                }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>

            <submit-contract-link-btn :user="currentUser" />
        </v-container>
    </v-card>
</template>
<script>
// models
import { User } from '../../models';
// components
import SubmitContractLinkBtn from '../../components/SubmitContractLinkBtn';
import { ROUTE_STATIC_PAGE } from '../../utils/constants';

export default {
    name: 'widget-wallet',
    components: {
        SubmitContractLinkBtn
    },
    props: {
        total: {
            required: true,
            type: Number
        }
    },
    computed: {
        staticRankUrl() {
            return { name: ROUTE_STATIC_PAGE, params: { slug: 'rank' } };
        },
        currentUser() {
            return User.getCurrent();
        }
    }
};
</script>
